import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lmr',
  templateUrl: './lmr.component.html',
  styleUrls: ['./lmr.component.sass'],
})
export class LmrComponent implements OnInit {
  cards = [
    {
      icon: 'gavel',
      label: 'BID',
      color: '#003B71',
      route: 'bid',
    },
    {
      icon: 'description',
      label: 'Cadastro do defeito e solução',
      color: '#FF6600',
      route: 'defect-solution',
    },
    {
      icon: 'devices_other',
      label: 'Matriz LMR',
      color: '#003B71',
      route: 'matriz',
    },
    {
      icon: 'store',
      label: 'Cadastro de Fornecedores',
      color: '#FF6600',
      route: 'dealers',
    },
    {
      icon: 'biotech',
      label: 'Acompanhamento de Reparo',
      color: '#003B71',
      route: 'acompanhamento-reparo',
    },
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {}

  goTo(route: string) {
    this.router.navigate([route]);
  }
}
